"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FiRepeat, FiTrash2 } from "react-icons/fi";
import { cx } from "@/lib/tailwind-utils";
import { MembershipShopCartLine } from "@/types/shop";
import { membershipBillingStartLabel } from "./utils";
const MembershipCartRow: React.FC<{
  line: MembershipShopCartLine;
  onRemove?: () => void;
}> = t0 => {
  const $ = _c(20);
  const {
    line,
    onRemove
  } = t0;
  const formName = line.form?.completed === false ? ` · ${line.form.name} required` : "";
  let t1;
  if ($[0] !== line.snapshot.imageUrl || $[1] !== line.snapshot.name) {
    t1 = <div className="relative flex h-10 w-10 flex-none items-center justify-center overflow-hidden rounded-xl bg-background-secondary text-primary">{line.snapshot.imageUrl ? <img src={line.snapshot.imageUrl} alt={line.snapshot.name} loading="lazy" className="h-full w-full object-cover" /> : <FiRepeat className="h-4 w-4" />}</div>;
    $[0] = line.snapshot.imageUrl;
    $[1] = line.snapshot.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== line.snapshot.name) {
    t2 = <p className="truncate text-body-emphasis text-foreground">{line.snapshot.name}</p>;
    $[3] = line.snapshot.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = line.snapshot.membership?.shopBillingStart;
  let t4;
  if ($[5] !== t3) {
    t4 = membershipBillingStartLabel(t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== formName || $[8] !== t4) {
    t5 = <p className="mt-0.5 truncate text-caption text-foreground-secondary">{t4}{formName}</p>;
    $[7] = formName;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="min-w-0 flex-1">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== line.snapshot.name || $[14] !== onRemove) {
    t7 = onRemove && <button type="button" onClick={onRemove} aria-label={`Remove ${line.snapshot.name} from cart`} className={cx("flex h-8 w-8 flex-none cursor-pointer items-center justify-center rounded text-foreground-secondary transition-colors", "hover:bg-hover hover:text-status-error-text focus:outline-none focus-visible:ring-2 focus-visible:ring-primary")}><FiTrash2 className="h-3.5 w-3.5" /></button>;
    $[13] = line.snapshot.name;
    $[14] = onRemove;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className="group flex items-start gap-3">{t1}{t6}{t7}</div>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export default MembershipCartRow;